// extracted by mini-css-extract-plugin
export default {"button":"_7ntTC"};